import { isNull, isString } from 'utils/type-checker';

export type StorageKey = string;
export type StorageValue = string | Object | null;

interface Writable {
  put(key: StorageKey, value: StorageValue): void;
  remove(key: StorageKey): boolean;
}

interface Readable {
  get(key: StorageKey): StorageValue;
  exist(key: StorageKey): boolean;
}

class Storage implements Writable, Readable {
  private prefix: string;
  private bucket: typeof localStorage;

  public constructor() {
    this.prefix = '__txd__';
    this.bucket = localStorage;
  }

  public put(key: StorageKey, value: StorageValue): void {
    if (typeof value === 'string') {
      this.bucket.setItem(this.key(key), value);
    }

    if (typeof value === 'object') {
      this.bucket.setItem(this.key(key), JSON.stringify(value));
    }
  }

  public remove(key: StorageKey): boolean {
    this.bucket.removeItem(key);

    if (this.exist(key)) {
      return false;
    }

    return true;
  }

  public get(key: StorageKey): StorageValue {
    let value: StorageValue = this.bucket.getItem(this.key(key));

    if (isString(value)) {
      return value;
    }

    return JSON.parse(value as string);
  }

  public reset(): void {
    this.bucket.clear();
  }

  public exist(key: StorageKey): boolean {
    key = this.key(key);

    if (isNull(this.bucket.getItem(key))) {
      return false;
    }

    return true;
  }

  private key(name: string): string {
    return this.prefix + name;
  }
}

export default Storage;
